import { c as _c } from "react/compiler-runtime";
import { Badge } from '@common/components';
import { SvgChevronright } from '@common/icon';
import { CustomLink } from '@/app/_components/CustomLink';
import { Image } from '@/components/client';
interface BenefitMenuRowProps {
  imageUrl?: string;
  title: string;
  description?: string;
  isNew: boolean;
  //* url 항목은 링크 이동, placementKey 항목은 onSelect로 오퍼월을 연다. 둘 다 없으면 비활성.
  href?: string;
  onSelect?: () => void;
}
const ROW_CLASS_NAME = 'group -mx-8 flex w-full items-center justify-between rounded-xsmall px-8 py-12 transition-colors focus-visible:bg-Gray-25 active:bg-Gray-50 xl:hover:bg-Gray-25';
const RowChevron = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <SvgChevronright className="size-16 shrink-0 text-Gray-400 transition group-focus-visible:translate-x-1 group-focus-visible:text-Gray-600 xl:group-hover:translate-x-1 xl:group-hover:text-Gray-600" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export const BenefitMenuRow = t0 => {
  const $ = _c(27);
  const {
    imageUrl,
    title,
    description,
    isNew,
    href,
    onSelect
  } = t0;
  let t1;
  if ($[0] !== imageUrl) {
    t1 = <Image src={imageUrl} alt="" width={40} height={40} sizes="40px" className="size-40 shrink-0 rounded-small object-cover" />;
    $[0] = imageUrl;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== title) {
    t2 = <p className="font-600 text-Gray-900 typo-body4">{title}</p>;
    $[2] = title;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== isNew) {
    t3 = isNew ? <Badge className="bg-O-50 text-O-550">NEW</Badge> : null;
    $[4] = isNew;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t2 || $[7] !== t3) {
    t4 = <div className="flex items-center gap-8">{t2}{t3}</div>;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== description) {
    t5 = description ? <p className="break-keep font-600 text-Gray-600 typo-caption1">{description}</p> : null;
    $[9] = description;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t4 || $[12] !== t5) {
    t6 = <div className="flex flex-col items-start">{t4}{t5}</div>;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t1 || $[15] !== t6) {
    t7 = <div className="flex items-center gap-16">{t1}{t6}</div>;
    $[14] = t1;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  const info = t7;
  if (href) {
    let t8;
    if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
      t8 = <RowChevron />;
      $[17] = t8;
    } else {
      t8 = $[17];
    }
    let t9;
    if ($[18] !== href || $[19] !== info) {
      t9 = <CustomLink href={href} className={ROW_CLASS_NAME}>{info}{t8}</CustomLink>;
      $[18] = href;
      $[19] = info;
      $[20] = t9;
    } else {
      t9 = $[20];
    }
    return t9;
  }
  if (onSelect) {
    let t8;
    if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
      t8 = <RowChevron />;
      $[21] = t8;
    } else {
      t8 = $[21];
    }
    let t9;
    if ($[22] !== info || $[23] !== onSelect) {
      t9 = <button onClick={onSelect} className={ROW_CLASS_NAME}>{info}{t8}</button>;
      $[22] = info;
      $[23] = onSelect;
      $[24] = t9;
    } else {
      t9 = $[24];
    }
    return t9;
  }
  let t8;
  if ($[25] !== info) {
    t8 = <div aria-disabled="true" className="flex items-center justify-between rounded-xsmall py-12 opacity-50">{info}</div>;
    $[25] = info;
    $[26] = t8;
  } else {
    t8 = $[26];
  }
  return t8;
};